<div class="cards-list" #list>
    <ng-container *ngTemplateOutlet="filtersTemplate"></ng-container>
    <div *ngIf="currentItems.length">
      <div
        class="card-item"
        [class.enter]="item.entering"
        [class.leave]="item.leaving"
        *ngFor="let item of currentItems; let index = index; trackBy: cardTrackBy"
        (scroll)="onScrollEvent()"
      >
      <app-media-card (favoriteChanged)="handleFavoriteChange($event)" [content]="item.data"></app-media-card>
      </div>
    </div>
    <!-- Note: selectedTab replaced with showFavoritesOnly per REMOVE-OBJECTIF.txt requirements -->
    <div *ngIf="!currentItems.length && !isLoading && showNoData">
      <ng-container *ngIf="!showFavoritesOnly; else favoriteNoData">
        Aucun résultat
      </ng-container>
    </div>
    <ng-template #favoriteNoData>
      <div class="no-results">
        <app-favorite-no-data></app-favorite-no-data>
      </div>
    </ng-template>
    <div #bottomTag></div>
    <ng-container *ngTemplateOutlet="noItemsTemplate"></ng-container>
    <div class="loading-spinner" *ngIf="isLoading">
      <app-spinner></app-spinner>
    </div>
  </div>
  